import {connect, MapDispatchToPropsObject} from 'react-redux';
import {IEditorState} from '../../../redux/modules/editor/reducer';

import {
  connectEditor,
  disconnectEditor,
  changeCode,
} from '../../../redux/modules/editor/actions';

import {
  SessionEditorFirepad as Container,
  ISessionEditorFirepadProps,
} from './firepad-ui';

interface IStore {
  editor: IEditorState;
}

const mapStateToProps = (state: IStore) => ({
  connected: state.editor.editorConnected,
  editorValue: state.editor.value,
});

const mapDispatchToProps = {
  disconnectEditor,
  connectEditor,
  // @TODO Need to measure performance maybe would be better do not store code in store
  changeCode,
} as MapDispatchToPropsObject;

export const SessionEditorFirepad = connect<ISessionEditorFirepadProps, any, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(Container);
